import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import * as m from '@/paraglide/messages.js';

import { JobDetailContent } from './-components/JobDetailContent';
import { jobsApi } from './-components/jobsApi';

export const Route = createFileRoute('/{-$locale}/internships/')({
  component: RightPanel,
  errorComponent: ErrorComponent,
  pendingComponent: () => <LoadingSpinner message={m.loading_offer()} />,
});

function RightPanel() {
  const { page } = Route.useSearch();
  const { data } = jobsApi.useList(page);
  const firstId = data?.data?.jobs?.[0]?.job_id ?? '';
  const { data: jobData } = jobsApi.useDetail(firstId);

  return <JobDetailContent job={jobData?.data} />;
}
